import React, { Component } from "react";
import { Card, Table, Button, Accordion } from "react-bootstrap";

class Appointment extends Component {
  render() {
    return (
      <div class="HomeCards">
        <div className="pane">
          <div className="cell"></div>
        </div>
        <div className="HomeCard">
          <Card className="centeredText">
            <Card.Header className="mainColor">Kontakt</Card.Header>
            <Card.Body className="sameHeightCardAppointment">
              {/* <div>
                Sie finden meinen Salon "Friseurstudio Seekamp" unter folgender
                Adresse:
              </div> */}

              <div class="map-responsive">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9578.22500640018!2d8.8953443!3d53.1181596!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b1265f9d8d5cc7%3A0xf91145b0de5e6394!2sFriseurmeisterin%20Dominique%20Treder-Osigus!5e0!3m2!1sde!2sde!4v1696323230111!5m2!1sde!2sde"
                  style={{ border: 0 }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
                {/*<iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2394.4392027557255!2d8.896989716015257!3d53.120260999322156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b1265f9d8d5cc7%3A0xf91145b0de5e6394!2sFriseurstudio%20Seekamp%20Inh.%20Dominique%20Treder-Osigus!5e0!3m2!1sde!2sde!4v1614693118296!5m2!1sde!2sde"
                  style={{ border: 0 }}
                  allowfullscreen=""
                  loading="lazy"
            ></iframe>*/}
              </div>
              <Card.Text>
                <br></br>
                <br></br>
                <ol>
                  <li>Lilienthaler Heerstraße 376A, 28357 Bremen</li>
                  <li className="itemText">
                    <a href="tel:+49421274710">0421 / 27 47 10</a>
                  </li>
                  <li className="itemText">
                    <a href="tel:+491739129594">0173 / 91 29 594</a>
                  </li>
                  {/* <li>termin(at)friseurstudio-seekamp.de *</li> */}
                </ol>
                <p>Für Terminanfragen rufen Sie bitte durch!</p>
                {/* <br></br>
                <div className="subText">
                  *Anfragen per Email werden verzögert beantwortet. Bei einer
                  Anfrage per Mail stets den Namen, eine Rückrufnummer, den
                  Wunsch- und einen Alternativtermin angeben.
                </div> */}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
        <div className="HomeCard">
          <Card className="centeredText">
            <Card.Header className="mainColor">Öffnungszeiten</Card.Header>
            <Card.Body className="sameHeightCardAppointment">
              <Card.Text>
                <p className="bold " style={{ fontSize: "12px" }}>
                  {/* Aufgrund meiner Mutterschaft gelten aktuell folgende
                  Öffnungszeiten.
                  <br></br>
                  <br></br> 
                  Sollten Ihnen diese Zeiten nicht zusagen oder mein{" "}
                  <span className="bold mainColor">voller Terminkalender </span>
                  hat keinen weiteren Platz für einen{" "}
                  <span className="bold mainColor">kurzfristigen Termin</span>,
                  so <span className="bold mainColor">melden Sie sich</span>{" "}
                  bitte{" "}
                  <span className="bold mainColor">bei meiner Kollegin</span>{" "}
                  Sonja Nelz unter <br></br>
                  <br></br>
                  <span className="itemText">
                    <a href="tel:+491625272166">0162 / 52 72 166</a>
                  </span>*/}
                </p>
              </Card.Text>
              <Table>
                <tbody>
                  <tr>
                    <td>Montag</td>
                    <td>geschlossen</td>
                  </tr>
                  <tr>
                    <td>Dienstag</td>
                    <td>09:00 - 14:00</td>
                  </tr>
                  <tr>
                    <td>Mittwoch</td>
                    <td>09:00 - 14:00</td>
                  </tr>
                  <tr>
                    <td>Donnerstag</td>
                    <td>09:00 - 14:00</td>
                  </tr>
                  <tr>
                    <td>Freitag</td>
                    <td>09:00 - 14:00</td>
                  </tr>
                  <tr>
                    <td>Samstag</td>
                    <td>jeden letzten Samstag im Monat geöffnet</td>
                  </tr>
                  <tr>
                    <td>Sonntag</td>
                    <td>geschlossen</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default Appointment;
